import { createAction, props } from '@ngrx/store'
import { createAsyncConstants } from '../../shared/utils'
import { LocationCode } from '../location/location.types'
import { ServiceAvailability } from './advisories.types'

export const ACKNOWLEDGE_NON_BLOCKING_ADVISORY = 'ACKNOWLEDGE_NON_BLOCKING_ADVISORY'
export const RESET_ADVISORIES = 'RESET_ADVISORIES'
export const SERVICE_AVAILABILITY = createAsyncConstants('SERVICE_AVAILABILITY')

// Dispatched when the user acknowledges a non-blocking (enabled club)
// informational advisory by clicking Next in the dialog. Releases the navigation
// gate in handleNavigation$ so the location step proceeds while the advisory
// stays in the store for the side menu / service-tracking surfaces. Blocking
// advisories never dispatch this — their navigation stays gated by
// selectIsEnabled.
export const acknowledgeNonBlockingAdvisory = createAction(
  ACKNOWLEDGE_NON_BLOCKING_ADVISORY
)

export const serviceAvailabilityRequest = createAction(
  SERVICE_AVAILABILITY.REQUEST,
  props<{ payload: {
    clubCode: string,
    breakdownLatitude: number,
    breakdownLongitude: number,
    locationCode: LocationCode,
    zipCode: string,
  } }>()
)

export const serviceAvailabilitySuccess = createAction(
  SERVICE_AVAILABILITY.SUCCESS,
  props<{ payload: { serviceAvailability: ServiceAvailability } }>()
)

export const notifyServiceAvailabilityFailure = createAction(SERVICE_AVAILABILITY.FAILURE)

export const resetAdvisories = createAction(RESET_ADVISORIES)
